import { useSelector } from 'react-redux';

import { getDealPdfFetchStatus, getDealPdfUrl, getPdfLoadingStatus } from '@makemydeal/activities-request-proposal';
import { getShowroomWorkflowStatus } from '@makemydeal/dr-sales-checkin-store';
import { ApiRequestStatus } from '@makemydeal/dr-shared-types';

import { DEAL_SUMMARY_PDF_WORKFLOW_STATUSES } from './dealSummaryPdfWorkflowStatuses';

export const useHasDealSummaryLoaded = (): boolean => {
    const workflowStatus = useSelector(getShowroomWorkflowStatus);
    const dealPdfUrl = useSelector(getDealPdfUrl);
    const isDealPdfLoading = useSelector(getPdfLoadingStatus);
    const dealPdfFetchStatus = useSelector(getDealPdfFetchStatus);

    if (!DEAL_SUMMARY_PDF_WORKFLOW_STATUSES.includes(workflowStatus)) {
        return true;
    }

    if (dealPdfFetchStatus === ApiRequestStatus.Error) {
        return true;
    }

    return !!dealPdfUrl && !isDealPdfLoading;
};
